import { Component, OnInit, TemplateRef, Input } from '@angular/core';

import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap/modal';
import { FormGroup, Validators, FormBuilder, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MenurightsService } from './menurights.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TeamMgtService } from '../../teammgt/teammgt.service';
import { TeamMgt } from '../../teammgt/teammgt';
import { User } from '../../Master/user/user';
import * as $ from 'jquery';
import { UseraddService } from '../../Master/useradd/useradd.service';
declare let $: any;
@Component({
  selector: 'app-menurights',
  templateUrl: './menurights.component.html',
  styleUrls: ['./menurights.component.css']
})
export class MenurightsComponent implements OnInit {
  _mappedMenuActionList = [];
  actions = [];
  actionnew: any = [];
  actionList = [];
  _menuList: any = []; _actionList: any[];
  actionArray = [];
  checkedAll: boolean;
  menurightsForm: FormGroup;
  form: FormGroup;
  users: User[];
  childinput: number;
  user: User;
  edituser1: User;
  teams: TeamMgt[];
  team: TeamMgt;
  checkedstatus: boolean;
  usermenumapped: string;
  loading: boolean = false;
  @Input() parentuserid: number;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private menurightsService: MenurightsService,
    private _sanitizer: DomSanitizer,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private teamService: TeamMgtService,
    private UseraddService: UseraddService,
  ) {


    const formControls = this.actions.map(control => new FormControl(false));

    // Create a FormControl for the select/unselect all checkbox
    const selectAllControl = new FormControl(false);

    //this.actions = [{ 'actionid': '1', 'action': 'Read Only' }, { 'actionid': '2', 'action': 'Add' }, { 'actionid': '3', 'action': 'Edit' }, { 'actionid': '4', 'action': 'Delete' }];

    this.menurightsForm = this.formBuilder.group({

      menumapped: [''],
      selectAll: selectAllControl,
      actions: new FormArray(formControls)

    });

    if (this._menuList.length == 0) 
      this.loadmenu();


  }

  ngOnInit() {

    this.form = this.formBuilder.group({
    });

  }


  ngOnChanges() {

    if (this.parentuserid > 0) {

      this.childinput = this.parentuserid;


    }


    //this.menurightsForm.get('selectAll').setValue(false);            

  }





  loadaction() {
    
    this.menurightsService.GetAction().toPromise().then(res => {
      if (res != undefined) {

        if (res.length > 0) {
          res.forEach(item => {
            var data = JSON.parse(item.spgetactionlist);
            this.actions.push(data);
         });        

        }
      }
    }, error => { this.toastr.error('Error while getting data'); });
  }

  loadmenu() {

    this.menurightsService.GetAction().toPromise().then(resaction => {
      if (resaction != undefined) {

        if (resaction.length > 0) {

          resaction.forEach(item => {
            var data = JSON.parse(item.spgetactionlist);
            this.actions.push(data);

          });

          this.menurightsService.GetMenu().toPromise().then(res => {
            if (res != undefined) {
              if (res.length > 0) {
                res.forEach(item => {
                  var data = JSON.parse(item.spgetmenulist);
                  this._menuList.push({ data })
                });
              
                this.actions.map((o, i) => {
                  const control = new FormControl(); // if first item set to true, else false
                  (this.menurightsForm.controls.actions as FormArray).push(control);
                });
                if (this.childinput > 0) {
                  this.UseraddService.GetById(this.childinput).toPromise().then(
                    (res) => {
                      this.users = res;
                      this.edituser1 = this.users.find(y => y.userid == this.parentuserid);
                      this.usermenumapped = this.edituser1.menumapped;
                      var array = JSON.parse(this.usermenumapped)
                      //console.log(array);
                      if ((array != null) && (array != undefined)) {
                        array.forEach(data => {
                          if (data.action.length != 0) {
                            
                            this._menuList.forEach(item => {
                              //console.log(item);
                              if (item.data.menuid == data.menuid) {
                                //check the menu checkbox
                                let e2 = document.getElementById(data.menuid);
                                (<HTMLInputElement>e2).checked = true;
                                //check the action checkbox                    
                                data.action.forEach(a => {
                                  var actionChkName = data.menuid + '_' + a;
                                  let e3 = document.getElementById(actionChkName);
                                  (<HTMLInputElement>e3).checked = true;

                                });
                              }
                            });
                          }
                          else { this.checkedAll = true; }
                        });
                      }
                      var checkedany = 'false';
                      for (var value of this._menuList) {
                        if ($('#' + value.data.menuid).is(':checked')) {
                          checkedany = 'true';
                        }
                        else {
                          checkedany = 'false';
                          break;
                        }
                      }

                      if (checkedany == 'true') {
                        this.menurightsForm.get('selectAll').setValue(true);
                      }
                      if (checkedany == 'false') {
                        this.menurightsForm.get('selectAll').setValue(false);
                      }

                    }, error => {
                      //console.log(error);
                    });

                }
              }
            }
          }, error => { this.toastr.error('Error while getting menu data'); });


        }
      }
    }, error => { this.toastr.error('Error while getting action data'); });
   
  
  }




  reset() {

    this.menurightsForm.get('selectAll').setValue(false);
    this._menuList.forEach(item => {
      let e2 = document.getElementById(item.data.menuid);
      (<HTMLInputElement>e2).checked = false;
      this.actions.forEach(a => {
        if (a.actionid != '') {
          var actionId = '';
          actionId = item.data.menuid + '_' + a.actionid;
          let e6 = document.getElementById(actionId);
          (<HTMLInputElement>e6).checked = false;
          this.onCheckboxChange(item.data.menuid, a.actionid, false);
        }
      });
    });
  

    

  }

  selectAll(e) {

    //this.menurightsForm.get('selectAll').valueChanges.subscribe(bool => {
    //  this.menurightsForm
    //    .get('actions')
    //    .patchValue(Array(this.actions.length).fill(bool), { emitEvent: false });
    //});

    this.actionArray = [];

    if (e.currentTarget.checked == true) {
      this._menuList.forEach(item => {
        let e2 = document.getElementById(item.data.menuid);
        (<HTMLInputElement>e2).checked = true;
        this.actions.forEach(a => {
          if (a.actionid != '') {
            var actionId = '';
            actionId = item.data.menuid + '_' + a.actionid;
            if (a.actionid != 1) {
              let e6 = document.getElementById(actionId);
              (<HTMLInputElement>e6).checked = true;
              // this.onCheckboxChange(item.data.menuid, a.actionid, true);
            }
            else {
              let e6 = document.getElementById(actionId);
              (<HTMLInputElement>e6).checked = false;

            }
          }
        });

      });



    }

    if (e.currentTarget.checked == false) {
      this._menuList.forEach(item => {
        let e2 = document.getElementById(item.data.menuid);
        (<HTMLInputElement>e2).checked = false;


        this.actions.forEach(a => {
          if (a.actionid != '') {
            var actionId = '';
            actionId = item.data.menuid + '_' + a.actionid;
            let e6 = document.getElementById(actionId);
            (<HTMLInputElement>e6).checked = false;
            //this.onCheckboxChange(item.data.menuid, a.actionid, false);

          }
        });
      });
    }



    //this.menurightsForm.get('selectAll').valueChanges.subscribe(bool => {
    //  this.menurightsForm
    //    .get('actions')
    //    .patchValue(Array(this.actions.length).fill(bool), { emitEvent: false });
    //});


  }


  getselectedmenus() {
    this._mappedMenuActionList = [];


    this._menuList.forEach(item => {
      var selected = [];
      this.actions.forEach(a => {
        if (a.actionid != '') {
          var actionId = '';
          actionId = item.data.menuid + '_' + a.actionid;
          var a1 = document.getElementById(actionId);
          if ($('#' + actionId).is(':checked'))
            selected.push(a.actionid)
        }
      });

      this._mappedMenuActionList.push({
        'menuid': item.data.menuid,
        'action': selected
      });

    });

    return this._mappedMenuActionList;

  }





  getselectedmenuscheck() {


    this.checkedstatus = false;
    for (let item of this._menuList) {
      if ($('#' + item.data.menuid).is(':checked')) {
        this.checkedstatus = true;
        break;
      }
    }
    return this.checkedstatus;
  }


  onMenuChange(id, e) {






    //this.menurightsForm.get('selectAll').valueChanges.subscribe(bool => {
    //  this.menurightsForm
    //    .get('actions')
    //    .patchValue(Array(this.actions.length).fill(bool), { emitEvent: true });
    //});



    if (e.currentTarget.checked == false) {
      this.menurightsForm.get('selectAll').setValue(false);
      this.actions.forEach(a => {
        if (a.actionid != '') {
          var actionId = '';
          actionId = id + '_' + a.actionid;
          let e6 = document.getElementById(actionId);

          (<HTMLInputElement>e6).checked = false;
          this.onCheckboxChange(id, a.actionid, false);

        }
      });
      //console.log(this.actionArray);
    }


    else {

      var checkedany = 'false';


      for (var value of this._menuList) {
        if ($('#' + value.data.menuid).is(':checked')) {
          checkedany = 'true';
        }
        else {
          checkedany = 'false';
          break;
        }
      }

      //this._menuList.forEach(item => {

      //});





      if (checkedany == 'true') {
        this.menurightsForm.get('selectAll').setValue(true);
      }






      this.actions.forEach(a => {
        if (a.actionid != '') {
          var actionId = '';
          actionId = id + '_' + a.actionid;
          let e6 = document.getElementById(actionId);
          if (a.actionid != 1) {
            (<HTMLInputElement>e6).checked = true;
            this.onCheckboxChange(id, a.actionid, true);
          }
        }
      });
      //console.log(this.actionArray);
    }

  }





  onCheckboxChange(id, data, isChecked: boolean) {


    if (isChecked) {

      this.actionArray.push({ 'menuid': id, 'action': data });
    }
    else {
      this.actionArray.splice(this.actionArray.findIndex(e => e.action == data && e.menuid === id
      ), 1);
    }


    this._menuList.forEach(item => {
      var selected = [];

      if (item.data.menuid == id) {
        let e10 = document.getElementById(item.data.menuid);
        if (isChecked == true) {
          (<HTMLInputElement>e10).checked = true;
        }

        this.actions.forEach(a => {
          if (a.actionid != '') {
            var actionId = '';

            if (a.actionid == 1) {
              actionId = item.data.menuid + '_' + a.actionid;
              if (data == a.actionid) {
                if (isChecked == true) {
                  this.actions.forEach(a1 => {
                    if (a1.actionid != 1) {
                      actionId = item.data.menuid + '_' + a1.actionid;
                      let e6 = document.getElementById(actionId);
                      (<HTMLInputElement>e6).checked = false;
                    }
                  });
                }
                else {

                  (<HTMLInputElement>e10).checked = false;

                }
              }

            }


            else {

              var actionIdreadonly = 'false';
              var actionIdread = '';
              actionId = item.data.menuid + '_' + a.actionid;
              actionIdread = item.data.menuid + '_' + 1;
              let e6 = document.getElementById(actionIdread);

              //this.actions.forEach(a1 => {
              //  if (a1.actionid != 1) {
              //    actionId = item.data.menuid + '_' + a1.actionid;
              //    let e6 = document.getElementById(actionId);
              //    if ($('#' + actionId).is(':checked')) {
              //      actionIdreadonly = 'true';
              //      return;
              //    }
              //  }
              //});


              for (var a1 of this.actions) {
                if (a1.actionid != 1) {
                  actionId = item.data.menuid + '_' + a1.actionid;
                  let e6 = document.getElementById(actionId);
                  if ($('#' + actionId).is(':checked')) {
                    actionIdreadonly = 'true';
                    break;
                  }
                }
              }







              if (actionIdreadonly == 'false') {

                if ($('#' + item.data.menuid).is(':checked')) {

                  (<HTMLInputElement>e6).checked = true;
                }

              }


              else {
                (<HTMLInputElement>e6).checked = false;
              }



            }


          }

        });
      }
    });





  }



  teamchange(teamid: number) {


    if (teamid > 0) {
      this.teamService.Get().subscribe(
        (res) => {
          this.teams = res;
          this.team = this.teams.find(r => r.teammgtid == teamid);

          var array = JSON.parse(this.team.menumapped)
          //console.log(array);
          if ((array != null) && (array != undefined)) {
            array.forEach(data => {
              if (data.action.length != 0) {
                this._menuList.forEach(item => {
                  if (item.data.menuid == data.menuid) {

                    let e2 = document.getElementById(data.menuid);

                    (<HTMLInputElement>e2).checked = true;
                    //check the action checkbox
                    data.action.forEach(a => {
                      var actionChkName = data.menuid + '_' + a;
                      let e3 = document.getElementById(actionChkName);
                      (<HTMLInputElement>e3).checked = true;

                      this.onCheckboxChange(data.menuid, a, true);

                    });
                  }
                });
              }
              else { this.checkedAll = true; }
            });
          }

        }, error => {
          //console.log(error);
        });


    }
  }


  editusermenurights(menustring: string) {




  }

}


